/**
 * Self-contained build-time feature flag for Linked Wheel + Map (SDD-24 / WL-052b).
 *
 * WHY ITS OWN FILE (mirrors ShareVideoModal/featureFlag.js, gradientBuilder/
 * featureFlag.js): kept local so it can be reviewed/merged independently of the
 * parallel Hail-Mary branches that also touch src/constants. Defaults OFF; flipped
 * per environment via a REACT_APP_* build var. When OFF, every Connect/Network
 * surface (drill-down section, map view, access toggle) is never rendered and no
 * linked-wheels API route is called — behaviour is byte-identical to today. It
 * pairs with the backend settings.LINKED_WHEELS_ENABLED (which 404s every route
 * while OFF), so a half-flipped state degrades safely.
 *
 * At merge this can be folded into src/constants/featureFlags.js.
 */
const truthy = (v) => v === "true" || v === "1" || v === true;

export const LINKED_WHEELS_ENABLED = truthy(process.env.REACT_APP_LINKED_WHEELS_ENABLED);
